<div class="container-fluid">
  <div class="row mt-4">
    <div class="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
      <div class="card border-0">
        <div class="card-body">
          <div class="text-center mb-40 mt-4">
            <h4 class="secondary-font-medium f-24 mb-3">No Page Found</h4>
            <p class="primary-font-normal">
              Hey foodie! You seem lost, scan the QR code on your table.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
